import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import vuetify from "./plugins/vuetify"
import api from "./services/api"
import setupInterceptors from "./services/setupInterceptors"

Vue.prototype.$api = api
Vue.config.productionTip = false
setupInterceptors(store)

new Vue({
	router,
	store,
	vuetify,
	render: (h) => h(App),
}).$mount("#app")
